import Swal from "sweetalert2";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import React, { useState } from "react";
import { getLegajoByDataCierre, GuardarLiquidacion, MarcarLegajoLiquidacion } from "../../../api/marcacionApi.js";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { AiOutlineIssuesClose } from "react-icons/ai";

const Cierre = () => {
  const history = useHistory();
  const [fechaInicio, setfechaInicio] = useState();
  const [fechaFin, setfechaFin] = useState();
  const [ini, setIni] = useState();
  const [fin, setFin] = useState();
  const [legajos, setLegajos] = useState([]);
  const [gastos, setGastos] = useState([]);
  const [asistencia, setAsistencia] = useState([]);
  const location = useLocation();
  const items = location.state;
  const _ = require("lodash");

  const handleCierre = async () => {
    try {
      Swal.fire({
        title: "Cargando Datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });

      const idPaciente = items.IdPacientes;
      if (!idPaciente || !fechaInicio || !fechaFin) {
        Swal.fire({
          title: 'Paciente o Fecha Invalida',
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
        });
        return;
      }

      const idUsuario = "TODOS";
      // Se asume que la API devuelve un objeto con arrays: { legajo, gastos, asistencia }
      const datass = await getLegajoByDataCierre({ fechaInicio, fechaFin, idUsuario, idPaciente });
      const legajoData = _.filter(datass.legajo, row => row.IdLiquidacion == null);
      const gastosData = datass.gastos || [];
      const asistenciaData = datass.asistencia || [];

      if (legajoData.length === 0 && gastosData.length === 0 && asistenciaData.length === 0) {
        Swal.fire({
          title: 'No se Encontraron Datos',
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
        });
        setLegajos([]);
        setGastos([]);
        setAsistencia([]);
      } else {
        setLegajos(legajoData);
        setGastos(gastosData);
        setAsistencia(asistenciaData);
        setIni(fechaInicio);
        setFin(fechaFin);
        Swal.close();
      }
    } catch (err) {
      Swal.close();
      console.error(err);
    }
  };

  const handleGuardar = async () => {
    try {
      Swal.fire({
        title: "Cargando Datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });

      const idPaciente = items.IdPacientes;
      if (legajos.length === 0 && gastos.length === 0 && asistencia.length === 0) {
        if (!idPaciente || !ini || !fin) {
          Swal.fire({
            title: 'Paciente o Fecha Invalida',
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: true,
          });
          return;
        }
         Swal.fire({
            title: 'Sin Datos para Guardar',
            allowOutsideClick: false,
            showCancelButton: false,
            showConfirmButton: true,
          });
            return;
      }


      const { value: text } = await Swal.fire({
        input: "textarea",
        inputLabel: "Observacion",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Ingrese Observacion";
          }
        }
      });

      if (text) {
        const obs = text;
        const ID = await GuardarLiquidacion({ obs, fin, ini, idPaciente });
        const IDliquidacion = ID.idLiquidacionClientes;
        await MarcarLegajoLiquidacion({ IDliquidacion, idPaciente, fin, ini });
        history.push({ pathname: "/clientes" });
      }
    } catch (err) {
      Swal.close();
      console.error(err);
    }
  };

  return (
    <>
      <div key={items.IdPacientes}>
        <div className="col-xl-12">
          <div className="page-titles acti-space">
            <h2 className="heading sm-mb-0 mb-2">{items.NombrePaciente}</h2>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Cierres</h4>
              <div className="d-flex align-items-center">
                <label className="p-3">Fecha Inicio</label>
                <input type="date" className="form-control p-3" onChange={e => setfechaInicio(e.target.value)} />
                <label className="p-3">Fecha Fin</label>
                <input type="date" className="form-control p-3 m-2" onChange={e => setfechaFin(e.target.value)} />
                <Button className="form-control p-3" onClick={handleCierre}>Generar cierre</Button>
              </div>
            </div>
            <div className="card-body p-4">
              {/* Tabla de Legajos */}
              <Table responsive bordered className="primary-table-bordered" striped hover>
                <thead className="thead-primary">
                  <tr>
                    <th>Cuenta</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Fecha Entrada</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Hora Entrada</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Fecha Salida</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Hora Salida</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Horas Extras</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Horas Calculadas</th>
                    <th style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                    }}>Honorario Total</th>
                    <th>Obs.</th>
                  </tr>
                </thead>
                <tbody>
                  {legajos.map((item, i) => (
                    <tr key={i}>
                      <td>{item.Cuenta}</td>
                      <td>{item.FechaEntrada}</td>
                      <td>{item.HoraEntrada}</td>
                      <td>{item.FechaSalida}</td>
                      <td>{item.HoraSalida}</td>
                      <td>{item.Horaextra}</td>
                      <td>{item.HorasCalculadas}</td>
                      <td>{item.HonorarioTotal}</td>
                      <td>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id={`tooltip-${i}`}>{item.Observacion || 'Sin observación'}</Tooltip>}
                          trigger={['hover', 'focus']}
                          delay={{ show: 200, hide: 100 }}
                        >
                          <span className="d-inline-block" tabIndex={0}>
                            <AiOutlineIssuesClose style={{ cursor: 'pointer' }} />
                          </span>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Tabla de Gastos */}
              <h5 className="mt-4">Gastos</h5>
              <Table responsive bordered className="primary-table-bordered" striped hover>
                <thead className="thead-primary">
                  <tr>
                    <th>Asignado</th>
                    <th>fecha</th>
                    <th>gasto</th>
                    <th>monto</th>
                  </tr>
                </thead>
                <tbody>
                  {gastos.map((g, idx) => (
                    <tr key={idx}>
                      <td>{g.usuario}</td>
                      <td>{g.fecha}</td>
                      <td style={{
                        maxWidth: '150px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'wrap',
                      }}>{g.gasto}</td>
                      <td>{g.monto}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Tabla de Asistencia */}
              <h5 className="mt-4">Asistencia</h5>
              <Table responsive bordered striped hover>
                <thead className="thead-primary">
                  <tr>
                    <th>asignado</th>
                    <th>fecha</th>
                    <th>procedimiento</th>
                    <th>tipo</th>
                    <th>honorario</th>
                    <th>obs</th>
                  </tr>
                </thead>
                <tbody>
                  {asistencia.map((a, i2) => (
                    <tr key={i2}>
                      <td>{a.NombreAsignado}</td>
                      <td>{a.fecha}</td>
                      <td>{a.procedimiento}</td>
                      <td>{a.tipo}</td>
                      <td>{a.honorario}</td>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id={`tooltip-${i2}`}>{a.obs || 'Sin observación'}</Tooltip>}
                        trigger={['hover', 'focus']}
                        delay={{ show: 200, hide: 100 }}
                      >
                        <span className="d-inline-block" tabIndex={0}>
                          <AiOutlineIssuesClose style={{ cursor: 'pointer' }} />
                        </span>
                      </OverlayTrigger>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Button variant="primary" onClick={handleGuardar}>Guardar</Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cierre;
